import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import Home2 from "../../../../Assets/Images/home2.png";
import { Button } from "@material-ui/core";
import { useStyles } from "./Subscribe.css";

class Subscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.root}
        style={{
          backgroundImage: `url(${Home2})`,
        }}
      >
        <div className={classes.textStyle}>
          <h1>Subscribe Us</h1>
          <p style={{ fontSize: 20 }}>
            Subscribe us to get the latest news and content
          </p>

          <form>
            <TextField
              name="email"
              type="email"
              label="Email"
              variant="outlined"
              margin="normal"
              fullWidth
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            <Button variant="outlined" className={classes.buttonStyle}>
              Subscribe
            </Button>
          </form>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Subscribe);
